import { CarrierAndServiceSchema } from "@redotech/redo-fulfillment-carrier-common/carriers-and-services";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getCarrierServiceCombinations = {
  name: "getCarrierServiceCombinations" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({ options: z.array(CarrierAndServiceSchema) }),
};
